<template>
  <div class="md:fixed lg:fixed  md:top-0 lg:top-0 md:left-0 lg:left-0 md:w-full lg:w-full">
    <header
      class="lg:px-16 px-6 bg-primary-0 text-white flex flex-wrap items-center lg:py-0 py-2"
    >
      <div class="flex-1 flex justify-between items-center py-4">
        <a href="#">
          <div class="font-bold text-3xl">Elektrotechniek</div>
          <div class="font-light text-lg tracking-title">Van Hove</div>
        </a>
      </div>

      <label for="menu-toggle" class="pointer-cursor lg:hidden block"
        ><svg
          class="fill-current text-white"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
        >
          <title>menu</title>
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path></svg
      ></label>
      <input class="hidden" type="checkbox" id="menu-toggle" />

      <div class="hidden lg:flex lg:items-center lg:w-auto w-full" id="menu">
        <nav>
          <ul
            class="lg:flex items-center justify-between text-base pt-4 lg:pt-0"
          >
            <navitem v-for="item in navItems" :key="item.name" :to="item.to">
              {{ item.name }}
              <span class="pl-3">
                <fa :icon="item.icon"></fa>
              </span>
            </navitem>
          </ul>
        </nav>
      </div>
    </header>
  </div>
</template>

<script>
import navitem from '@/components/navbar/NavItem.vue';

export default {
  name: 'navbar',
  components: { navitem },
  data() {
    return {
      navItems: [
        { name: 'home', to: '#', icon: 'lightbulb' },
        { name: 'services', to: '#services', icon: 'bolt' },
        { name: 'contact', to: '#contact', icon: 'plug' },
      ],
    };
  },
};
</script>

<style lang="scss">
#menu-toggle:checked + #menu {
  display: block;
}
</style>
